import {all, fork} from "redux-saga/effects";

import * as authSaga from './authSaga';
import * as reservationSaga from './ReservationSaga';
import * as employeesSaga from './EmployeesSaga';
import * as carSaga from './CarSaga';
import * as serviceCitySaga from "./CitySaga";
import * as dutyTypeSaga from './DutyTypeSaga';
import * as companySaga from "./CompanySaga";
import * as operationSaga from "./OperationsSaga";
import * as rateCardSaga from './RateCardSaga';
import * as rateCalculationSaga from './RateCalculationSaga';
import * as googleMap from "./GoogleMapSaga";
import * as billingSaga  from "./BillingSaga";
import * as ProfileSaga  from "./ProfileSaga";
import * as Dashboard from "./DashboardSaga";
import * as AccountDeletion from "./accountDeletionSaga";
import * as PaymentSaga from "./PaymentSaga";


export default function* rootSaga() {
    yield all([
    ...Object.values(authSaga),
    ...Object.values(carSaga),
    ...Object.values(dutyTypeSaga),
    ...Object.values(serviceCitySaga),
    ...Object.values(employeesSaga),
    ...Object.values(reservationSaga),
    ...Object.values(operationSaga),
    ...Object.values(ProfileSaga),
    ...Object.values(companySaga),
    ...Object.values(rateCardSaga),
    ...Object.values(rateCalculationSaga),
    ...Object.values(googleMap),
    ...Object.values(billingSaga),
    ...Object.values(Dashboard),
    ...Object.values(AccountDeletion),
    ...Object.values(PaymentSaga)
   ].map(fork));
  }